import { useState, useEffect, useContext } from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Row } from "react-bootstrap";
import FilesData from "../pages/FilesData";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import VN from "../components/VN";
import { UserDataContext } from "../components/UserDataContext";
import { useNavigate } from "react-router-dom";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  const navigate = useNavigate();
  const { userData } = useContext(UserDataContext);

  useEffect(() => {
    if (userData && userData.permId === "2") {
      navigate("/nopermission");
    }
  }, [userData, navigate]);

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

export default function Performers() {
  const { userData } = useContext(UserDataContext);
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <div>
      <VN userData={userData} />
      <ThemeProvider theme={theme}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="underMenu"
          variant="scrollable"
          scrollButtons
          allowScrollButtonsMobile
        >
          <Tab label="Dokumenty bieżące" />
          <Tab label="Dokumenty zaksięgowane" />
        </Tabs>
      </ThemeProvider>

      <CustomTabPanel value={value} index={0}>
        <Row>
          <FilesData />
        </Row>
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <Row>{/* <PerformersActivity perm="2" /> */}</Row>
      </CustomTabPanel>
    </div>
  );
}
